import * as types from '../mutation-types'
import RegionsApi from "../../api/regions";
import axios from "axios";

// state
export const state = {
    all: []
};

// getters
export const getters = {
    all: state => state.all
};

// mutations
export const mutations = {
    [types.AFFILIATE_PROGRAM_CATEGORIES_ALL_SET] (state, all) {
        state.all = all;
    }
};

// actions
export const actions = {
    async fetch(context) {
        const { data } = await axios.get('/api/affiliate_programs/categories');
        context.commit(types.AFFILIATE_PROGRAM_CATEGORIES_ALL_SET, data);
    },
};
